'use strict';

const isMobileWidth = () => {
    const tabletWidth = 768;

    return $(window).width() < tabletWidth;
};

module.exports = isMobileWidth;
